/* @flow */
import Image from 'components/Image.jsx';
import InviteModal from 'users/components/InviteModal.jsx';
import Link from 'components/Link.jsx';
import ModalTrigger from 'components/ModalTrigger.jsx';
import React, { Component } from 'react';
import UniversalComposeButtonContainer from 'chat/containers/UniversalComposeButtonContainer.jsx';

import LAUNCH_IMG_SRC from 'assets/images/group-launch.svg';

import styles from './styles/GroupMessagesNull.css';

/**
 * Used to display a null state in a group message list before any messages are available.
 *
 * It has many possible states.

  # With standard inline composer

  ## User can post
  ```example
    <GroupMessagesNull
      canPost
    />
  ```

  ## User can post and has history
  ```example
    <GroupMessagesNull
      canPost
      messageHistoryEnabled
    />
  ```

  ## User can't post, but can chat
  e.g. student/parent in 2-way

  ```example
    <GroupMessagesNull
      canChat
    />
  ```

  ## User can't post or chat
  e.g. student/parent in 2-way

  ```example
    <GroupMessagesNull
    />
  ```
 *
 */
export default class GroupMessagesNull extends Component {
  static propTypes = {
    canChat: React.PropTypes.bool,
    canInviteTeachers: React.PropTypes.bool,
    canPost: React.PropTypes.bool,
    messageHistoryEnabled: React.PropTypes.bool,
  };

  static defaultProps = {
    canChat: false,
    canPost: false,
    canInviteTeachers: false,
    messageHistoryEnabled: false,
  };

  getPosterUI() {
    const title = 'Send a welcome message!';
    const subtitle = 'Let your class know how you’ll be using Remind.';
    const subtext = <UniversalComposeButtonContainer label="Send an announcement" />;

    return { title, subtitle, subtext };
  }

  getReceiverUI() {
    const title = 'No announcements yet';

    let subtitle = '';
    if (this.props.canInviteTeachers) {
      subtitle = (
        <div>
          While you’re waiting,{' '}
          <ModalTrigger modal={<InviteModal />}>
            <Link className={styles.link}>share Remind</Link>
          </ModalTrigger>
          {' '}with other teachers!
        </div>
      );
    } else if (this.props.canChat) {
      subtitle = (
        <span>In the meantime, click on the New Message button to send
        your teacher questions, updates, and more.</span>
      );
    } else {
      subtitle = (
        <span>We’ll let you know as soon as your<br />teacher sends an
        announcement.</span>
      );
    }

    let subtext = '';
    if (this.props.canChat) {
      subtext = (
        <div>
          <UniversalComposeButtonContainer label="Send a message" />
        </div>
      );
    }

    return { title, subtitle, subtext };
  }

  render() {
    const image = (<Image src={LAUNCH_IMG_SRC} />);

    const { title, subtitle, subtext } = this.props.canPost ?
      this.getPosterUI() :
      this.getReceiverUI();

    return (
      <div className={styles.this}>
        <div className={styles.image}>{image}</div>
        <div className={styles.title}>{title}</div>
        <div className={styles.subtitle}>{subtitle}</div>
        <div className={styles.subtext}>{subtext}</div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/groups/components/GroupMessagesNull.jsx